import { buttonTypeVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const stickyActionBar = tv({
    slots: {
        root: 'shadow-card w-full bg-neutral-1/90 shadow-overlay-md backdrop-blur-2xl',
        headerContainer: '',
        contentWrapper: 'px-4 pt-4 pb-2',
        mainContainer: 'flex flex-row items-center justify-between gap-2 pb-2',
        textContainer: 'basis-full',
        actionContainer: 'basis-full',
        helperTextSlot: 'text-center text-body3',
        primaryActionContainer: 'flex flex-[2]',
        secondaryActionContainer: 'flex flex-1',
        tertiaryActionContainer: 'flex shrink-0'
    },
    variants: {
        type: buttonTypeVariants,
        barType: {
            bookBar: {
                mainContainer: 'flex flex-row items-center justify-between gap-2 pb-2',
                textContainer: 'basis-full',
                actionContainer: 'basis-full'
            },
            actionBar: {
                mainContainer: 'flex flex-row items-center justify-between gap-2',
                textContainer: 'basis-full',
                actionContainer: 'flex w-full flex-row gap-2'
            }
        },
        actionDisplay: {
            lg: {},
            mdRight: {
                mainContainer: 'flex flex-row items-center justify-end gap-2 pb-2',
                actionContainer: 'flex shrink-0 flex-row items-center gap-1'
            },
            mdStacked: {
                mainContainer: 'flex flex-col items-end gap-2 pb-2',
                actionContainer: 'flex w-full flex-col gap-2'
            }
        },
        floating: {
            true: {
                root: 'overflow-clip rounded-2xl shadow-penny-md',
                contentWrapper: 'px-1 pt-1 pb-0'
            },
            false: {}
        },
        actionCount: {
            one: {
                actionContainer: 'flex w-full'
            },
            two: {
                actionContainer: 'flex w-full flex-row gap-2'
            },
            three: {
                actionContainer: 'flex w-full flex-row gap-2'
            }
        }
    },
    compoundVariants: [
        {
            barType: 'actionBar',
            actionCount: 'two',
            class: {
                actionContainer: 'flex w-full flex-row gap-2'
            }
        },
        {
            barType: 'actionBar',
            actionCount: 'three',
            class: {
                actionContainer: 'flex w-full flex-row gap-2'
            }
        },
        {
            actionDisplay: 'mdRight',
            class: {
                actionContainer: 'flex w-auto flex-none flex-row justify-end gap-2',
                primaryActionContainer: 'flex flex-none',
                secondaryActionContainer: 'flex flex-none',
                tertiaryActionContainer: 'flex flex-none'
            }
        },
        {
            actionDisplay: 'mdStacked',
            class: {
                actionContainer: 'flex w-full flex-col gap-2'
            }
        },
        {
            barType: 'bookBar',
            actionDisplay: 'mdRight',
            class: {
                mainContainer: 'flex flex-row items-center justify-between gap-2 pb-2'
            }
        },
        {
            barType: 'bookBar',
            actionCount: 'two',
            class: {
                textContainer: 'grow basis-0',
                actionContainer: 'flex grow-[2] basis-0 flex-row gap-2',
                primaryActionContainer: 'flex flex-1',
                secondaryActionContainer: 'flex flex-1',
                tertiaryActionContainer: 'flex flex-1'
            }
        },
        {
            barType: 'bookBar',
            actionCount: 'three',
            class: {
                textContainer: 'grow basis-0',
                actionContainer: 'flex grow-[3] basis-0 flex-row gap-2',
                primaryActionContainer: 'flex flex-1',
                secondaryActionContainer: 'flex flex-1',
                tertiaryActionContainer: 'flex flex-1'
            }
        },
        {
            barType: 'bookBar',
            actionDisplay: 'mdRight',
            class: {
                textContainer: 'min-w-0 grow basis-0',
                actionContainer: 'flex w-auto flex-none flex-row items-center gap-1',
                primaryActionContainer: 'flex flex-none',
                secondaryActionContainer: 'flex flex-none',
                tertiaryActionContainer: 'flex flex-none'
            }
        },
        {
            barType: 'bookBar',
            actionDisplay: 'mdRight',
            floating: true,
            class: {
                textContainer: 'min-w-0 grow basis-0 pl-2'
            }
        },
        {
            barType: 'bookBar',
            actionDisplay: 'mdStacked',
            class: {
                mainContainer: 'flex flex-col items-center justify-center gap-2 pb-2',
                textContainer: 'flex w-full justify-center text-center [&>*]:justify-center',
                actionContainer: 'flex w-full flex-col gap-2',
                primaryActionContainer: 'flex w-full',
                secondaryActionContainer: 'flex w-full',
                tertiaryActionContainer: 'flex w-full'
            }
        },
        {
            floating: true,
            actionDisplay: 'mdRight',
            class: {
                contentWrapper: 'px-1 pt-1 pb-0',
                mainContainer: 'pb-1'
            }
        }
    ],
    defaultVariants: {
        type: 'primary',
        barType: 'actionBar',
        actionDisplay: 'lg',
        floating: false,
        actionCount: 'one'
    }
});
export { stickyActionBar };
